<template>
  <div class="view-container">
    <div class="extended-filter-block">
      <h2>Оценка</h2>
      <div class="extended-search-block-mobile">
        <div class="search-outline-block">
          <SearchOutlined @click="showMobileFilterModal = true" style="color: rgba(0, 0, 0, 0.45)" />
          <div v-if="currentFiltersLine" class="dot"></div>
        </div>
      </div>
    </div>

    <div class="card">
      <a-table
               :columns="getExtendedColumns('tests', 'Оценка ЭИ')"
               rowKey="id" :data-source="tableData.tests?.children ?? []"
               :scroll="{ x: 800 }"
               :pagination="false"
               :locale="{ emptyText: emptySlot()}"
               :table-layout="'fixed'"
               :loading="summaryIsLoading"
      />
      <div class="order-button">
        <a-button class="secondary-button" @click="currentAction = 'show_details'">
          Об отчетах
        </a-button>
        <a-button class="secondary-button" @click="showOrderForm = true">
          Заказать продукт
        </a-button>
      </div>
    </div>

    <div class="card">

      <a-table
          rowKey="id"
          :columns="columns"
          :data-source="staff"
          :scroll="{ x: 2500 }"
          :row-selection="{ selectedRowKeys: selectedUsers, onChange: onSelectChange }"
          :pagination="false"
          :loading="tableLoading"
          @change="handleTableChange"
          :table-layout="'fixed'"
      >

        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'name'">
            <a class="staff-link" @click="router.push(`/staff/${record.id}/edit`)">{{ text }}</a>
          </template>

          <template v-if="column.dataIndex === 'status'">
            <div v-if="record.last_test_passing">
              <a-tag color="green" v-if="record.last_test_passing.status === 'finished'">
                Завершен
              </a-tag>
              <a-tag class="yellow-tag" v-else-if="record.last_test_passing.status === 'new'">
                Не начат
              </a-tag>
              <a-tag color="red" v-else-if="record.last_test_passing.status === 'expired'">
                Просрочен
              </a-tag>
              <a-tag class="blue-tag" v-else>
                В процессе
              </a-tag>
            </div>
            <a-tag v-else>
              Не выдан
            </a-tag>
          </template>

          <template v-if="column.dataIndex === 'report_type'">
            <span v-if="record.last_test_passing">
              {{ getReportName(record.last_test_passing.report_type).replace('ТЭИ:', '') }}
            </span>
          </template>

          <template v-if="column.dataIndex === 'activated_at'">
            <span v-if="record.last_test_passing">
              {{ record.last_test_passing.activated_at_formatted ?? '' }}
            </span>
          </template>

          <template v-if="column.dataIndex === 'completion_time'">
            <div v-if="record.last_test_passing">
              <span v-if="!record.last_test_passing.completion_anomaly || !record.last_test_passing.anomaly_detail">
              {{ record.last_test_passing.completion_time ?? '' }}
              </span>
              <a-popover v-else title="Обратите внимание">
                <template #content>
                  <p>{{ record.last_test_passing.anomaly_detail }}</p>
                </template>
                <span> {{ record.last_test_passing.completion_time ?? '' }} <InfoCircleOutlined style="color: var(--warning-color-1)" /></span>
              </a-popover>
            </div>
          </template>

          <template v-if="column.dataIndex === 'started_at'">
            <span v-if="record.last_test_passing">
              {{ record.last_test_passing.started_at ?? ''}}
            </span>
          </template>

          <template v-if="column.dataIndex === 'finished_at'">
            <span v-if="record.last_test_passing">
              {{ record.last_test_passing.finished_at ?? ''}}
            </span>
          </template>

          <template v-if="column.dataIndex === 'expires_at'">
            <span v-if="record.last_test_passing">
              {{ record.last_test_passing.expires_at ?? ''}}
            </span>
          </template>

          <template v-if="column.dataIndex === 'results'">
            <div>
              <span class="green-text" @click="handleAction('show-reports', record)">
                Отчеты
              </span>

              <span class="green-text"  @click="handleAction('show-courses', record)">
                История обучения
              </span>
            </div>
          </template>

          <template v-if="column.dataIndex === 'groups'">
            <a-tag v-for="(group) in record.groups" :key="group.id" style="margin-bottom: 4px">
              {{ group.name }}
            </a-tag>
          </template>

          <template v-if="column.dataIndex === 'action'">
            <a-dropdown :trigger="['click']" placement="bottomLeft">
              <a-button type="text" @click.prevent>
                <MenuOutlined />
              </a-button>

              <template #overlay>
                <a-menu @click="({key}) => handleAction(key, record)">
                  <a-menu-item key="remind" v-if="record.last_test_passing && record.last_test_passing.status !== 'finished'">Напомнить</a-menu-item>
                  <a-menu-item key="manage_access">Управлять доступами</a-menu-item>
                  <a-menu-item key="set_visibility">Настроить видимость отчетов</a-menu-item>
                  <a-menu-item key="download_reports">Скачать все отчеты</a-menu-item>
                  <a-menu-item key="export">Экспортировать</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </template>

        <template #emptyText>
          <div class="no-data-wrapper">
            <img :src="NotFoundIcon" class="no-data-image" alt="Нет результатов"/>

            <div class="no-data-text">
              {{
                currentFiltersLine
                    ? 'Нет данных для отображения. Измените фильтры или запрос.'
                    : 'Нет данных для отображения. Добавьте сотрудников, чтобы начать работу.'
              }}
            </div>

            <a-button
                v-if="currentFiltersLine"
                @click="resetFilters"
            >
              <template #icon>
                <ReloadOutlined />
              </template>
              Сбросить фильтры
            </a-button>
          </div>
        </template>

      </a-table>

      <div class="bottom-container">
        <div class="action-block">
          <div class="action-select-wrapper">
            <a-select
                v-model:value="actionToApply"
                :placeholder="'Выберите действие'"
                style="width: 100%;"
                @change="() => handleAction(actionToApply)"
                :not-found-content="'Нет данных'"
                :disabled="!selectedUsers.length"
            >
              <a-select-option v-for="e in actions" :key="e.id" :value="e.id">
                {{ e.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <a-pagination v-model:current="currentPage"
                      :page-size="entitiesPerPage"
                      :buildOptionText="(count) => `${count.value} / стр`"
                      :show-total
                          ="total => `Всего ${total ?? 0} элементов`"
                      :total="totalUsers"
                      @change="handlePageChange"
        />
      </div>
    </div>

    <ManageAccessForm
        :open="currentAction === 'manage_access'"
        v-if="currentAction === 'manage_access'"
        @close="clearCurrentUserAndAction"
        @showStaff="() => {
              selectedUsers = [];
              clearCurrentUserAndAction();
              resetFilters();
            }"
        @showOrderForm="() => {
              clearCurrentUserAndAction();
              showOrderForm = true;
            }"
        :userData="currentActionUser ? [currentActionUser.id] : selectedUsers"
        :name="currentActionUser ? currentActionUser.name : null"
        :mode="'staff'"
    />

    <UsersFilterMobileForm
        v-if="showMobileFilterModal"
        :open="showMobileFilterModal"
        @close="showMobileFilterModal = false"
        :groups="groups"
    />

    <AboutTestsModal
        :open="currentAction === 'show_details'"
        v-if="currentAction === 'show_details'"
        @close="clearCurrentUserAndAction"
    />

<!--    <PassingReportTypes-->
<!--        :open="currentAction === 'show-reports'"-->
<!--        v-if="currentAction === 'show-reports'"-->
<!--        :passings="currentPassing"-->
<!--        @close="clearCurrentUserAndAction"-->
<!--        @getAdditionalReports="(data) => {-->
<!--          showAdditionalReportModal = true;-->
<!--          originalPassingRecord = data;-->
<!--        }"-->
<!--    />-->

    <DetailsPassings
        :open="currentAction === 'show-courses'"
        v-if="currentAction === 'show-courses'"
        :courses="coursesToShow"
        @close="clearCurrentUserAndAction"
    />

<!--    <GenerateAdditionalReport-->
<!--        v-if="showAdditionalReportModal && originalPassingRecord"-->
<!--        :originalPassing="originalPassingRecord"-->
<!--        :open="showAdditionalReportModal"-->
<!--        @closeForm="clearCurrentUserAndAction"-->
<!--        @generated="refresh"-->
<!--    />-->

    <NewOrderForm v-if="showOrderForm" :open="showOrderForm" @close="showOrderForm = false" />
  </div>
</template>


<script>
import {onBeforeMount, onBeforeUnmount, reactive, ref, watch} from "@vue/runtime-core";
import {h, onMounted} from "vue";
import NotFoundIcon from "@/assets/images/icons/no_data.svg";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import {computed} from "@vue/reactivity";
import {
  SearchOutlined,
  SettingOutlined,
  PlusOutlined,
  ReloadOutlined,
  MenuOutlined,
  DownOutlined,
  ClockCircleOutlined, InfoCircleOutlined
} from '@ant-design/icons-vue'
import ManageAccessForm from "@/components/Forms/Access/ManageAccessForm.vue";
import NewOrderForm from "@/views/Orders/OrderForm.vue";
import UsersFilterMobileForm from "@/feature/users/UsersFilterMobileForm.vue";
import getReportName from "../../mixins/getReportName";
import AboutTestsModal from "../../feature/testing/modals/AboutTestsModal.vue";
import {message} from "ant-design-vue";
import DetailsPassings from "./DetailsPassings.vue";
import PassingReportTypes from "../../components/Cards/PassingReportTypes.vue";
import GenerateAdditionalReport from "@/feature/testing/forms/GenerateAdditionalReport.vue";

export default {
  name: 'new-groups',
  components: {
    GenerateAdditionalReport,
    PassingReportTypes,
    DetailsPassings,
    InfoCircleOutlined,
    AboutTestsModal,
    UsersFilterMobileForm,
    NewOrderForm,
    ManageAccessForm,
    SearchOutlined, SettingOutlined, PlusOutlined, ReloadOutlined, MenuOutlined, DownOutlined},
  setup() {

    const store = useStore(),
        router = useRouter();

    const showOrderForm = ref(false);
    const actionToApply = ref();
    const showActionModal = ref();
    const currentAction = ref();
    const modalActionLoading = ref(false);
    const tableLoading = ref(true);
    const groupsLoading = ref(true);
    const statusError = ref({
      groupName: null,
    });

    const showAdditionalReportModal = ref(false);

    const actionButtonLabels = {
      copy: 'Копировать',
      delete: 'Удалить',
      merge: 'Объединить',
      create: 'Создать'
    }

    const showMobileFilterModal = ref(false);
    const specialStaff = computed(() => store.state.users.specialStaff);
    const blockedStaff = computed(() => store.state.users.showBlocked);
    const hidePagination = ref(false);
    const currentPassing = ref([]);

    const allGroups = computed(() => store.state.group.groups);
    const groups = ref([]);

    const manageGroupAccessUsers = ref([]);

    const coursesToShow = ref([]);
    const originalPassingRecord = ref(null);

    const selectedUsers = ref([]);
    const currentActionUser = ref({
      id: null,
      name: '',
      groups: [],
    });

    const showFilterModal = ref(false);
    const entitiesPerPage = ref(10);
    const currentPage = ref(1);
    const filtersPopoverOpen = ref(false);

    const getShortListColumns = (key, mainTitle) => {
      return [
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 550,
          align: 'left',
        },
        {
          title: 'Доступ',
          dataIndex: 'has_access',
          key: 'has_access',
          width: 70,
          align: 'right',
        },
        {
          title: 'Истекает',
          dataIndex: 'validUntil',
          key: 'validUntil',
          width: 100,
          align: 'center',
          customRender: renderClockIcon,
        },
      ];
    }

    const renderClockIcon = ({ record }) => {
      const children = [h('span', record.validUntil)];

      if (record.timeRemaining && record.timeRemaining < 30) {
        children.push(
            h(ClockCircleOutlined, {
              class: 'circle-clock',
              style: {
                color: '#FAAD14',
              },
            }),
        );
      }

      return h(
          'div',
          {
            style: {
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              columnGap: '2px',
              flexDirection: 'row-reverse',
              lineHeight: '1.2',
            },
          },
          children
      );
    }

    const columns = computed(() => [
      {
        dataIndex: 'action',
        title: () =>
            h(SettingOutlined, {
              style: {
                color: '#999',
              },
            }),
        width: 30,
        align: 'center',
      },
      {
        title: 'Сотрудник',
        dataIndex: 'name',
        sorter: true,
        width: 250,
      },
      {
        title: 'Статус',
        dataIndex: 'status',
        sorter: false,
        width: 150,
      },
      {
        title: 'Тип отчета',
        dataIndex: 'report_type',
        sorter: false,
        width: 190,
      },
      {
        title: 'Дата выдачи',
        dataIndex: 'activated_at',
        sorter: false,
        width: 120,
      },
      {
        title: 'Дата начала',
        dataIndex: 'started_at',
        sorter: false,
        width: 120,
      },
      {
        title: 'Длительность',
        dataIndex: 'completion_time',
        sorter: false,
        width: 120,
      },
      {
        title: 'Дата завершения',
        dataIndex: 'finished_at',
        sorter: false,
        width: 150,
      },
      {
        title: 'Результаты',
        dataIndex: 'results',
        sorter: false,
        width: 200,
      },
      {
        title: 'Должность',
        dataIndex: 'job_title',
        sorter: true,
        width: 150,
      },
      {
        title: 'Почта',
        dataIndex: 'email',
        sorter: true,
        width: 190,
      },
      {
        title: 'Группы',
        dataIndex: 'groups',
        width: 250,
      },
      {
        title: 'Истекает',
        dataIndex: 'expires_at',
        width: 250,
      },
      {
        title: 'Последний вход',
        dataIndex: 'online_from',
        width: 250,
      },
    ]);

    const actions = [
      {
        id: 'remind',
        name: 'Напомнить'
      },
      {
        id: 'manage_access',
        name: 'Управлять доступами'
      },
      {
        id: 'set_visibility',
        name: 'Настроить видимость отчетов'
      },
      {
        id: 'download_reports',
        name: 'Скачать все отчеты'
      },
      {
        id: 'export',
        name: 'Экспортировать'
      },
    ];

    const filters = computed(() => store.state.users.filters);
    const currentFiltersLine = computed(() => store.state.users.filterString);
    const companyActivityData = computed(() => store.state.companyActivity);

    const totalUsers = computed(() => store.state.users.staffWithProductsTotal);
    const staff = computed(() => store.state.users.staffWithProducts);

    const tableData = reactive({
      tests: []
    });

    const emptySlot = () =>
        h('div', { class: 'no-data-wrapper' }, [
          h('img', { src: NotFoundIcon, class: 'no-data-image'}),
          h('div', {class: 'no-data-text'}, 'Нет данных для отображения'),
        ]);

    const summaryIsLoading = ref(false);

    const prepareProducts = () => {
      let companyTotalPurchased = (companyActivityData.value?.tests?.total_counts?.total?.issued_users_count ?? 0) + (companyActivityData.value?.tests?.total_counts?.total?.free_count ?? 0)

      tableData.tests = {
          id: 1,
          product: 'Оценка',
          purchased: companyTotalPurchased,
          issued: companyActivityData.value?.tests?.total_counts?.total?.issued_users_count ?? 0,
          remaining: companyActivityData.value?.tests?.total_counts?.total?.free_count ?? 0,
          completed: companyActivityData.value?.tests?.total_counts?.total?.finished_count ?? 0,
          validUntil: companyActivityData.value?.tests?.total_counts?.total?.closest_expiring_date ?? null,
          timeRemaining: companyActivityData.value?.tests?.total_counts?.total?.remaining_active_days ?? null,
          children: companyActivityData.value?.tests?.total_counts ? getSubTestProducts(companyActivityData.value?.tests?.total_counts) : null,
        }
    }

    const getSubTestProducts = (array) => {
      let subProductsArray = Object.entries(array)
          .filter(([key]) => key !== 'total')
          .map(([key, value]) => {
            return {
              product: getReportName(key),
              purchased: value.all_count,
              issued: value.issued_users_count,
              remaining: value.free_count,
              completed: value.finished_count,
              validUntil: value.expires_at,
              timeRemaining: value.remaining_active_days,
            }});

      if (!subProductsArray || !subProductsArray.length) {
        return null;
      }

      return subProductsArray;
    }

    const onSelectChange = selectedRowKeys => {
      selectedUsers.value = selectedRowKeys;
    };

    // фильтры
    const openFilterModal = () => {
      showFilterModal.value = true;
    }

    const updateFilters = () => {
      filtersPopoverOpen.value = false;
      showMobileFilterModal.value = false;

      currentPage.value = 1;
      fetchUsers();
    }

    const clearCurrentUserAndAction = () => {
      currentAction.value = '';
      actionToApply.value = null;
      showActionModal.value = false;
      currentActionUser.value = {
        id: null,
        name: '',
        groups: [],
      }
      coursesToShow.value = [];
      showAdditionalReportModal.value = false;
      originalPassingRecord.value = null;
      currentPassing.value = [];
    }

    const refresh = () => {
      showAdditionalReportModal.value = false;
      originalPassingRecord.value = null;
      currentAction.value = null;
      currentPassing.value = [];

      fetchUsers();
    }

    const handleAction = (action, userObject = null) => {
      if (userObject) {
        currentActionUser.value.id = userObject.id;
        currentActionUser.value.groups = userObject.groups.map((group) => group.id);
        currentActionUser.value.name = userObject.name;
      } else {
        currentActionUser.value = null;
      }

      if (action === 'remind') {
        remindAboutTest();
        return;
      }

      if (action !== 'export') {
        currentAction.value = action;

        if (action === 'show-courses') {
          coursesToShow.value = userObject.courses ?? [];
          return;
        }

        if (action === 'show-reports') {
          currentPassing.value = userObject.tests ?? [];
          return;
        }
        
        showActionModal.value = true;
      }
    }

    const resetFilters = () => {
      store.dispatch('users/setUserFilters', {
        filters: {
          name: '',
          job_title: '',
          department: '',
          online_from: '',
          created_at: '',
          email: '',
          telephone: '',
          groups: [],
          without_group_only: false,
        },
        filterString: null,
      });

      currentPage.value = 1;
      fetchUsers();
    }

    //сортировка
    const sortState = ref({
      field: null,
      order: null,
    });

    const handleTableChange = (pagination, filter, sorter) => {
      sortState.value = {
        field: sorter?.field ?? null,
        order: sorter?.order ?? null,
      };

      fetchUsers();
    }

    const getExtendedColumns = (key, mainTitle) => {
      return [
        {
          title: mainTitle,
          dataIndex: 'product',
          key: 'product',
          width: 110,
          align: 'left',
        },
        {
          title: 'Куплено',
          dataIndex: 'purchased',
          key: 'purchased',
          width: 60,
          align: 'right',
        },
        {
          title: 'Выдано',
          dataIndex: 'issued',
          key: 'issued',
          width: 60,
          align: 'right',
        },
        {
          title: 'Осталось',
          dataIndex: 'remaining',
          key: 'remaining',
          width: 60,
          align: 'right',
        },
        {
          title: 'Завершено',
          dataIndex: 'completed',
          key: 'completed',
          width: 60,
          align: 'right',
        },
        {
          title: 'Истекает',
          dataIndex: 'validUntil',
          key: 'validUntil',
          width: 45,
          align: 'center',
          customRender: renderClockIcon,
        },
      ]
    }

    const fetchUsers = () => {
      tableLoading.value = true;

      store.dispatch("users/getStaffProducts", {
        special_staff: specialStaff.value?.length ? specialStaff.value : null,
        is_blocked: blockedStaff.value ?? null,
        per_page: entitiesPerPage.value,
        page: currentPage.value,
        sort_field: sortState.value.field,
        sort_direction:
            sortState.value.order === 'ascend'
                ? 'asc'
                : sortState.value.order === 'descend'
                    ? 'desc'
                    : null,
        ...filters.value
      }).then(() => {

        if (specialStaff.value?.length) {
          hidePagination.value = true;
          store.dispatch('users/clearSpecialStaff');
        } else if (hidePagination.value) {
          hidePagination.value = false;
        }

        store.dispatch('users/clearShowBlocked');

        tableLoading.value = false;
      });
    }

    // пагинация
    const retrieveEntitiesPerPage = () => {
      let storageValue = localStorage.getItem('perPage');
      entitiesPerPage.value = storageValue ? Number(storageValue) : 10;
    }

    const setEntitiesPerPage = (num) => {
      localStorage.setItem('perPage', num)
    }

    const handlePageChange = (current, perPage) => {
      if (entitiesPerPage.value !== perPage) {
        entitiesPerPage.value = perPage;
        setEntitiesPerPage(entitiesPerPage.value);
      }

      currentPage.value = current;
      fetchUsers();
    }

    const isMobile = ref(window.innerWidth < 768)

    const onResize = () => {
      isMobile.value = window.innerWidth < 768
    }

    onMounted(() => {
      window.addEventListener('resize', onResize)
    });

    const clearCurrentAction = () => {
      currentAction.value = null;
      currentAction.value = null;
      actionToApply.value = null;

      showActionModal.value = false;
      manageGroupAccessUsers.value = [];
      currentPassing.value = [];
    }

    const fetchAfterSubmit = () => {
      clearCurrentAction();
      fetchUsers();
    }

    onBeforeMount(() => {
      store.dispatch("group/getGroups").then(() => {
        groups.value = allGroups.value.map((group) => {
          return {
            id: group.id,
            name: group.name,
          }
        });

        groupsLoading.value = false;
      });

      summaryIsLoading.value = true;

      store.dispatch('getCompanyActivity').then(() => {
        prepareProducts();
      }).finally(() => {
        summaryIsLoading.value = false;
      })

      retrieveEntitiesPerPage();
      fetchUsers();
    });

    const remindAboutTest = async () => {
      if (currentActionUser.value) {
        const passing = staff.value.find((el) => el.id === currentActionUser.value.id).last_test_passing;

          if (passing.status !== 'finished') {
            sendReminder(passing.code);
        }
      } else {
        selectedUsers.value.map((id) => {
          const passing = staff.value.find((el) => el.id === id).last_test_passing;

          if (passing.status !== 'finished') {
            sendReminder(passing.code);
          }
        });
      }

      message.success('Напоминания отправлены');
    };

    const sendReminder = (code) => {
      store.dispatch("test/remindTest", code);
    }

    onBeforeUnmount(() => {
      store.dispatch('group/clearGroupFilters');
    });

    watch(filters, () => {
          updateFilters();
        },
        { deep: true, immediate: true }
    );

    return {
      getReportName,
      router,
      NotFoundIcon,
      currentPage,
      entitiesPerPage,
      columns,
      actionToApply,
      actions,
      groups,
      onSelectChange,
      currentFiltersLine,
      tableLoading,
      showFilterModal,
      openFilterModal,
      updateFilters,
      filtersPopoverOpen,
      totalUsers,
      handlePageChange,
      showMobileFilterModal,
      handleTableChange,
      isMobile,
      showActionModal,
      modalActionLoading,
      statusError,
      actionButtonLabels,
      clearCurrentAction,
      manageGroupAccessUsers,
      showOrderForm,
      fetchAfterSubmit,
      resetFilters,
      clearCurrentUserAndAction,
      selectedUsers,
      currentAction,
      currentActionUser,
      tableData,
      getShortListColumns,
      emptySlot,
      summaryIsLoading,
      staff,
      handleAction,
      getExtendedColumns,
      coursesToShow,
      showAdditionalReportModal,
      originalPassingRecord,
      refresh,
      currentPassing
    }
  }
}
</script>

<style scoped lang="scss">
.view-container {
  padding-top: 0;
  margin-top: 0;
}

.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 0;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
}

.extended-search-block-mobile {
  display: none;
  margin-right: 10px;

  @media(max-width: 768px) {
    display: block;
  }
}

:deep(.anticon-reload) {
  cursor: pointer;
}

:deep(.anticon-reload:hover) {
  color: var(--main-green) !important;
}

.orders-control {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  margin-bottom: 16px;
}

.search-outline-block {
  position: relative;
}

.dot {
  position: absolute;
  top: -1px;
  left: 11px;
  height: 5px;
  width: 5px;
  background-color: var(--color-error);
  border-radius: 50%;
}

h2 {
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
}

.pagination-block {
  margin-left: auto;
  margin-top: 20px;
}

:deep(.ant-table-thead >tr>th) {
  padding: 5px 10px !important;
}

:deep(.ant-table-tbody>tr:not(.ant-table-measure-row)>td) {
  padding: 10px 5px !important;
}

.inner-table {
  background: #fafafa;

  :deep(.ant-table-tbody) {
    background: #fafafa;
  }

  :deep(.ant-table-wrapper .ant-table-tbody >tr >td >.ant-table-wrapper:only-child .ant-table) {
    margin-block: 0 !important;
  }

  :deep(.ant-table.ant-table-empty) {
    margin-block: 0 !important;
  }

  :deep(thead th) {
    color: var(--grey-text);
    border-bottom: unset;
  }
}

.orders-table {
  position: relative;
}

.expand-header-gear {
  position: absolute;
  top: 8px;
  left: 10px;
  z-index: 1;
  font-size: 14px;
  color: var(--grey-text);
}

.user-link {
  cursor: pointer;
  color: var(--main-green);
}

.user-link:hover {
  color: var(--hover-color);
}

.order-button {
  display: flex;
  column-gap: 8px;
  margin-top: 16px;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
    row-gap: 8px;
  }
}

.bottom-container {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 15px;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
  }
}


.no-data-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 5px;
  padding: 24px;
}

.no-data-wrapper button {
  margin-top: 10px;
}

.no-data-wrapper button:hover {
  border-color: var(--main-green);
  color: var(--main-green);
}

:deep(.ant-btn-text.ant-dropdown-trigger) {
  color: lightgrey;
}

:deep(.ant-btn-text.ant-dropdown-trigger.ant-dropdown-open) {
  color: var(--main-font);
}

:deep(.ant-table-tbody .ant-dropdown-trigger) {
  padding: 4px 5px !important;
}

.action-select-wrapper {
  min-width: 180px;

  @media (max-width: 550px) {
    width: 100%;

    .ant-select {
      width: 100%;
    }
  }
}

:deep(.ant-table-thead >tr>th) {
  padding: 5px 10px !important;
}

:deep(.ant-table-tbody>tr:not(.ant-table-measure-row)>td) {
  padding: 10px 5px !important;
}

.inner-table {
  background: #fafafa;

  :deep(.ant-table-tbody) {
    background: #fafafa;
  }

  :deep(.ant-table-wrapper .ant-table-tbody >tr >td >.ant-table-wrapper:only-child .ant-table) {
    margin-block: 0 !important;
  }

  :deep(.ant-table.ant-table-empty) {
    margin-block: 0 !important;
  }

  :deep(thead th) {
    color: var(--grey-text);
    border-bottom: unset;
  }
}

.orders-table {
  position: relative;
}

.expand-header-gear {
  position: absolute;
  top: 8px;
  left: 10px;
  z-index: 1;
  font-size: 14px;
  color: var(--grey-text);
}

.green-text ,
.user-link {
  cursor: pointer;
  color: var(--main-green);
}

.green-text:hover,
.user-link:hover {
  color: var(--hover-green);
}

:deep(.ant-table-row-expand-icon-cell) {
  width: 20px !important;
  min-width: 20px !important;
  max-width: 20px !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  text-align: center;
}

.order-button {
  @media(max-width: $mobile-breakpoint) {
    button {
      width: 100%;
    }
  }
}
</style>